import { useQuery } from "@tanstack/react-query"
import { getBackofficeClusterSnapshotsQuery } from "modules/backoffice/lib/canonicalTopics/getBackofficeClusterSnapshotsQuery"

export function useGetBackofficeClusterSnapshotsQuery(
  ...args: Parameters<typeof getBackofficeClusterSnapshotsQuery>
) {
  return useQuery(getBackofficeClusterSnapshotsQuery(...args))
}
